import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FormattedMessage } from '../../../components/I18n';
import useToggle from '../../../hooks/useToggle';
import styled, { theme } from '../../../utils/Styling'; // @ts-expect-error Could not find a declaration file for module

import { useFetchFilters } from '../../../hooks/catalogPageHooks'; // @ts-expect-error Could not find a declaration file for module

import MobileTopFilterPanel from '../../../containers/TracksPage/MobileTopFilterPanel';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
const FilterIcon = styled(UIIcon).withConfig({
  displayName: "PlaylistAssignmentsMobileFilter__FilterIcon",
  componentId: "sc-1einz8e-0"
})(["vertical-align:middle;"]);
const FilterButton = styled(UIButton).withConfig({
  displayName: "PlaylistAssignmentsMobileFilter__FilterButton",
  componentId: "sc-1einz8e-1"
})(["color:", " !important;width:auto !important;&&{padding-left:0 !important;padding-right:0 !important;}margin-bottom:8px;"], theme.colors.EERIE);
const FilterPanel = styled(MobileTopFilterPanel).withConfig({
  displayName: "PlaylistAssignmentsMobileFilter__FilterPanel",
  componentId: "sc-1einz8e-2"
})(["z-index:2222;"]);

const PlaylistAssignmentsMobileFilter = () => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    tracksLessonsSearchQueryData
  } = useFetchFilters();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FilterButton, {
      "data-test-id": "mobile-filter-panel-button",
      onClick: show,
      use: "transparent",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.filters.filtersLink"
      }), /*#__PURE__*/_jsx(FilterIcon, {
        color: theme.colors.EERIE,
        name: "filter",
        size: 22
      })]
    }), /*#__PURE__*/_jsx(FilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: tracksLessonsSearchQueryData && tracksLessonsSearchQueryData.length || 0,
      mobileFilterTypes: [FILTER_TYPES.ASSIGNED_BY],
      onCloseClick: hide,
      open: isShowing,
      showSort: false
    })]
  });
};

export default PlaylistAssignmentsMobileFilter;